module.exports = __webpack_public_path__ + "static/images/styles/images/reserves/tactical-training-clan-landing-elite-big.51e04e1f.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/reserves/tactical-training-clan-landing-elite-big.png
// module id = 3804
// module chunks = 11